<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-card class="mt-2 pb-8 mb-5" flat>
					<v-card-title>
						<v-subheader>
							<span class="title font-weight-normal"
								>Filtrar plano de ação</span
							>
						</v-subheader>
						<v-spacer></v-spacer>
						<v-btn
							v-show="!view"
							class="white--text mr-2"
							depressed
							color="#34bfa3"
							@click="$router.push('/plan-action/new')"
							>+ Novo</v-btn
						>
						<v-btn class="white--text" depressed color="info" @click="filter()"
							>Buscar</v-btn
						>
						<search-filter-default v-model="filters" :filterId="true" />
					</v-card-title>
				</v-card>
				<v-card flat>
					<v-data-table
						:headers="headers"
						:items="items"
						:items-per-page="pagination.itemsPerPage"
						v-bind:loading="loading"
						loading-text="Aguarde...carregando"
						:hide-default-footer="true"
					>
						<template v-slot:body="{ items }">
							<tr v-for="item in items" :key="item.CODPLA">
								<td v-if="!view">
									<v-btn @click="edit(item.CODPLA)" icon>
										<v-icon style="color: orange">mdi-pencil</v-icon>
									</v-btn>
								</td>
								<td v-else>&nbsp;</td>
								<td>{{ item.CODPLA }}</td>
								<td>{{ item.strategicplanning.DESABR }}</td>
								<td>{{ item.company.DESABR }}</td>
								<td>{{ item.unit.DESABR }}</td>
								<td>{{ item.area.DESARE }}</td>
								<td>{{ item.DESPLA }}</td>
								<td v-if="!view">
									<v-btn @click="remove(item.CODPLA)" icon>
										<v-icon style="color: red">mdi-delete</v-icon>
									</v-btn>
								</td>
								<td v-else>
									<v-btn @click="edit(item.CODPLA)" icon>
										<v-icon>mdi-eye</v-icon>
									</v-btn>
								</td>
							</tr>
						</template>
					</v-data-table>

					<pagination
						v-model="pagination"
						@change="loadData"
						:loading="loading"
					/>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import PlanActionService from "../../app/Services/PlanActionService";
import pagination from "@/components/pagination/Pagination.vue";
import PaginationMixin from "@/components/pagination/PaginationMixin";
import SortableMixin from "@/components/pagination/sort/SortableMixin";
import searchFilterDefault from "@/components/searchFilterDefault/searchFilterDefault.vue";

export default {
	name: "PlanActionList",
	components: { searchFilterDefault, pagination },
	mixins: [PaginationMixin, SortableMixin],
	async mounted() {
		await this.loadData();
	},
	data: () => ({
		loading: false,
		view: false,
		filters: {},
		headers: [
			{
				text: "",
				align: "left",
				sortable: false,
				value: "status",
				width: "10%"
			},
			{
				text: "Código",
				align: "left",
				sortable: true,
				value: "CODPLA",
				width: "10%"
			},
			{
				text: "Planej.",
				align: "left",
				sortable: true,
				value: "strategicplanning.DESABR",
				width: "10%"
			},
			{
				text: "Empresa",
				align: "left",
				sortable: true,
				value: "company.DESABR",
				width: "10%"
			},
			{
				text: "Unidade",
				align: "left",
				sortable: true,
				value: "unit.DESABR",
				width: "10%"
			},
			{
				text: "Area",
				align: "left",
				sortable: true,
				value: "area.DESARE",
				width: "20%"
			},
			{
				text: "Descrição",
				align: "left",
				sortable: true,
				value: "DESPLA"
			},
			{
				text: "",
				align: "left",
				sortable: false,
				value: "status",
				width: "3%"
			}
		],
		items: []
	}),
	methods: {
		toast(type, message, icon = "mdi-check") {
			this.$toasted.show(message, {
				type: type,
				icon: icon
			});
		},
		async loadData() {
			try {
				this.loading = true;
				const filter = this.filters;

				const query = {
					params: {
						filter,
						...this.pagination
					}
				};

				const response = await PlanActionService.build().index({
					query
				});

				this.items = response.data;
				this.loading = false;

				this.paginate(response);
			} catch (e) {
				// eslint-disable-next-line no-console
				console.log(e);
				this.defaultCatchError(e);
			} finally {
				this.loading = false;
			}
		},
		filter() {
			this.searching = true;
			this.items = [];
			this.pagination.page = 1;

			this.loadData();
		},
		edit(id) {
			this.$router.push({
				name: "PlanActionEdit",
				params: {
					id: id,
					view: this.view
				}
			});
		},
		remove(id) {
			PlanActionService.build()
				.destroy({
					id: id
				})
				.then(() => {
					this.toast(
						"success",
						"Plano de ação removida com sucesso!"
					);

					this.loadData();
				});
		}
	}
};
</script>
